/**
 * Get decoded token
 *
 * @param {String} token
 * @returns
 */
function _getToken(token) {
    let decodedToken
    try {
        decodedToken = JSON.parse(atob(token.split('.')[1]))
    } catch (err) {
        console.error(err)
    }
    return decodedToken
}

/**
 * Get expiration date from token
 *
 * @param {String} token
 * @returns
 */
export function getExpDateFromToken(token) {
    return _getToken(token).exp * 1000
}

/**
 * Get `is_owning_tenant` from token
 *
 * @param {String} token
 * @returns
 */
export function getIsOwningTenantFromToken(token) {
    return _getToken(token).is_owning_tenant
}

/**
 * Get `child_org_ids` from token
 *
 * @param token
 * @returns {[]}
 */
export function getChildOrgIdsFromToken(token) {
    return _getToken(token)?.child_org_ids
}

/**
 * Get `company_id` from token
 *
 * @param token
 * @returns
 */
export function getCompanyIDFromToken(token) {
    return _getToken(token)?.company_id || '656'
}
